var exports = {
  "p": "avatarFlipMotion__3uzMrs",
  "mU": "authFormHeader__psacN8",
  "Vg": "authFormHeaderIcon__BRUCgi",
  "d6": "authFormHeaderContent__mffsTx",
  "ZJ": "authFormAvatarWrapper__8UU4fg",
  "B0": "authFormAvatarCoin__B4F7hd",
  "Ur": "avatarCoinCover__Q3zUQF",
  "G9": "avatarCoinInnerCover__1cn8Xs",
  "iR": "avatarCoinBack__ADehNZ",
  "C8": "avatarCoinInnerBack__bIM_E0",
  "pO": "avatarCoinWeight__wDLjP2",
  "SP": "avatarCoinGithub__nQko6U",
  "JM": "authFormAvatarWrapperStatic__GzAKXm",
  "Yi": "authFormHeaderTitle__oGeDKl",
  "Bq": "authFormParagraph__4Mh2gX",
  "dj": "userAvatar__cnwkTN",
};

module.exports = exports;
